var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnLive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 73,
    viewBox: "0 0 118 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 118,
    height: 72,
    rx: 4,
    fill: "url(#paint0_linear_5005_1642)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7983 53.5V21.82H18.7823V47.912H32.4223V53.5H12.7983ZM39.243 53.5V21.82H45.227V53.5H39.243ZM61.2825 53.5L51.6025 21.82H57.7625L65.6825 47.868L73.7345 21.82H79.8945L70.2145 53.5H61.2825ZM85.8486 53.5V21.82H106.529V27.408H91.8326V34.184H103.889V39.772H91.8326V47.912H106.529V53.5H85.8486Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5005_1642",
    x1: 0.970441,
    y1: 72.5,
    x2: 114.501,
    y2: -3.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09D785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098CAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLive);
export default __webpack_public_path__ + "static/media/btn-live.c51c8684de4c341a8422ccf941764502.svg";
export { ForwardRef as ReactComponent };